import { render, staticRenderFns } from "./DogProfiles.vue?vue&type=template&id=5fe60df7"
import script from "./DogProfiles.vue?vue&type=script&lang=ts"
export * from "./DogProfiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports